import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-[#2b2826] text-[#f2efeb] py-6 border-t border-[#403a35]" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-122">
          {/* Left: Logo */}
          <div className="flex items-center" data-id="element-123">
            <Logo data-id="element-124" />
          </div>

          {/* Right: Social + copyright + legal */}
          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8" data-id="element-125">
            <div className="flex items-center gap-3" data-id="element-126">
              <a href="#" aria-label="Facebook" className="text-[#f2efeb]/50 hover:text-[#c9a875] transition-colors" data-id="element-127">
                <FacebookIcon className="w-4 h-4" data-id="element-128" />
              </a>
              <a href="#" aria-label="Twitter" className="text-[#f2efeb]/50 hover:text-[#c9a875] transition-colors" data-id="element-129">
                <TwitterIcon className="w-4 h-4" data-id="element-130" />
              </a>
              <a href="#" aria-label="Instagram" className="text-[#f2efeb]/50 hover:text-[#c9a875] transition-colors" data-id="element-131">
                <InstagramIcon className="w-4 h-4" data-id="element-132" />
              </a>
              <a href="#" aria-label="LinkedIn" className="text-[#f2efeb]/50 hover:text-[#c9a875] transition-colors" data-id="element-133">
                <LinkedinIcon className="w-4 h-4" data-id="element-134" />
              </a>
            </div>

            <div className="flex items-center gap-5 text-xs text-[#f2efeb]/40 font-light" data-id="element-135">
              <span data-id="element-136">&copy; {new Date().getFullYear()} ScaleWithLending</span>
              <Link to="/privacy" className="hover:text-[#f2efeb]/70 transition-colors" data-id="element-137">
                Privacy
              </Link>
              <Link to="/terms" className="hover:text-[#f2efeb]/70 transition-colors" data-id="element-138">
                Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};